import { EntityCard } from '@vizit/molecules';
import { cva, cx } from '@vizit/theme';
import type * as React from 'react';

const styles = {
  container: cva({ base: 'flex flex-col gap-8' }),
  grid: cva({ base: 'grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3' }),
};

export interface EntityGridItem {
  id: string;
  name: string;
  href: string;
  meta?: React.ReactNode;
}

export interface EntityGridProps {
  items: EntityGridItem[];
  isLoading?: boolean;
  loadingCount?: number;
  emptyState?: React.ReactNode;
  className?: string;
}

function EntityGrid(props: EntityGridProps) {
  const { items, isLoading = false, loadingCount = 6, emptyState, className } = props;

  return (
    <div className={cx(styles.container(), className)} data-testid="entity-grid">
      {!isLoading && items.length === 0 ? (
        <div data-testid="entity-grid-empty">{emptyState ?? null}</div>
      ) : (
        <ul className={styles.grid()}>
          {isLoading
            ? Array.from({ length: loadingCount }, (_, index) => `entity-grid-skeleton-${index}`).map((key) => (
                <li key={key}>
                  <EntityCard id={key} name="" href="#" isLoading />
                </li>
              ))
            : items.map((item) => (
                <li key={item.id}>
                  <EntityCard id={item.id} name={item.name} href={item.href} meta={item.meta} />
                </li>
              ))}
        </ul>
      )}
    </div>
  );
}

export { EntityGrid };
